import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';

import MobileFilter from '@buyside/components/presentation/IndexPageHeader/Filters/mobileFilter';
import StickyFilter from '@buyside/components/presentation/IndexPageHeader/Filters/stickyFilter';

import { useIsMobile } from '@buyside/util/hooks/useIsMobile';

import styles from './indexPageHeaderStyles.scss';

const IndexPageHeader: FC<{
  additionalStickyElement?: ReactElement | null;
  header: string | null;
  isDarkTheme?: boolean;
  renderCheckboxes?: () => ReactElement;
  renderFilters: () => ReactElement;
  renderSideButtons?: () => ReactElement;
  renderSortOrders?: () => ReactElement;
  resultCount?: number;
  showMoreLess?: boolean;
}> = ({
  additionalStickyElement,
  header,
  isDarkTheme,
  renderCheckboxes,
  renderFilters,
  renderSideButtons,
  renderSortOrders,
  resultCount,
  showMoreLess
}) => {
  const isMobile = useIsMobile();

  return (
    <>
      {header ? (
        <div className={styles.header}>
          <h3>{header}</h3>
          <div className={styles.flexRow}>{renderSideButtons && renderSideButtons()}</div>
        </div>
      ) : null}
      <div
        className={classNames(styles.filterContainer, {
          [styles.mobileFilterContainer]: isMobile,
          [styles.darkThemeFilterContainer]: isDarkTheme
        })}
      >
        {isMobile ? (
          <MobileFilter>{renderFilters()}</MobileFilter>
        ) : (
          <StickyFilter
            isDarkTheme={isDarkTheme}
            showMoreLess={showMoreLess}
            additionalElement={additionalStickyElement}
          >
            {renderFilters()}
          </StickyFilter>
        )}
        <div className={styles.resultsContainer}>
          <div className={styles.checkboxFilters}>{renderCheckboxes && renderCheckboxes()}</div>
          <div className={styles.sortOrder}>
            {resultCount === undefined ? null : (
              <span>
                {resultCount
                  ? `${resultCount} result${resultCount === 1 ? '' : 's'}`
                  : '-- results'}
                {renderSortOrders && ' sorted by:'}
              </span>
            )}
            {renderSortOrders && renderSortOrders()}
          </div>
        </div>
      </div>
    </>
  );
};

export default IndexPageHeader;
